import React from 'react';

import {Container, withStyles} from '@material-ui/core';

import {useSpinner} from 'hooks';
import {Constants} from 'commons';
import {EfeTrack} from 'components';
import {useSnackbar} from 'notistack';
import {CatalogServices, KeycloakService} from 'services';
import {EfeCatalog, EfeResponse} from 'commons/models';
import {EfeFlowProvider} from 'providers';
import {Routing, Sidebar} from 'layouts/commons';
import {InferPropTypes} from 'commons/types/Types';
import {AdminStyles} from 'assets/tss/layouts/admin';
import {getCatalogMessage} from 'commons/utils/Messagefunctions';
import {useMenuContext} from 'context/onboarding-menu/OnboardingMenu';
import EfeUserProvider from 'providers/efe-user-provider/EfeUserProvider';
import {useCatalogContext} from 'context/onboarding-catalog/OnboardingCatalog';
import {INITIAL_CATALOGS_LOAD, SnackbarVariants, USER_DATA} from 'commons/constants';
import EfeBeneficiaryProvider from 'providers/efe-beneficiary-provider/EfeBeneficiaryProvider';
import EfeRelatedPeopleProvider from 'providers/efe-related-people-provider/EfeRelatedPeopleProvider';

function Admin(props: InferPropTypes<typeof Admin.propTypes, typeof AdminStyles>) {
    const {classes} = props;
    const {menu} = useMenuContext();
    const {enqueueSnackbar} = useSnackbar();
    const {uploadData} = useCatalogContext();
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [enableTracking, setEnableTracking] = React.useState<boolean>(false);
    const catalogs: Array<EfeCatalog> = [];

    async function onIdle() {
        const logout: EfeResponse<number> = await KeycloakService.logout(USER_DATA);
        USER_DATA.logout = true;
        USER_DATA.loggedIn = false;
        setEnableTracking(false);

    }

    React.useEffect(() => {
        setEnableTracking(USER_DATA.loggedIn);
    }, [USER_DATA.loggedIn]);

    React.useEffect(() => {
        if (
            (!catalogs || catalogs.length <= 0) &&
            USER_DATA.token &&
            USER_DATA.loggedIn &&
            !USER_DATA.logout
        ) {
            (async () => {
                setIsLoading(true);
                const joinedValues = INITIAL_CATALOGS_LOAD.map(item => item.value).join(',');
                try {
                    const response = await CatalogServices.getCatalogs(joinedValues);
                    console.log(response.data);
                    if (response.data) {
                        catalogs.push(...response.data);
                    } else {
                        enqueueSnackbar(getCatalogMessage('Inicial'), {
                            variant: SnackbarVariants.ERROR,
                        });
                    }
                } catch (error) {
                    enqueueSnackbar(getCatalogMessage('Desconocido'), {
                        variant: SnackbarVariants.ERROR,
                    });
                    console.error(error);
                }
                // for (const catalog of INITIAL_CATALOGS_LOAD) {
                //     try {
                //         const response = await CatalogServices.getValuesFrom(catalog.value);
                //         console.log(response.data);
                //         if (response.data && response.data.values && response.data.values.length) {
                //             catalogs.push({...response.data});
                //         } else {
                //             enqueueSnackbar(getCatalogMessage(catalog.label), {
                //                 variant: SnackbarVariants.ERROR,
                //             });
                //         }
                //     } catch (error) {
                //         enqueueSnackbar(getCatalogMessage(catalog.label), {
                //             variant: SnackbarVariants.ERROR,
                //         });
                //     }
                // }
                setIsLoading(false);
                uploadData(catalogs);
            })();
        }
    }, [USER_DATA.username, USER_DATA.email]);

    return (
        <EfeTrack
            enableTracking={enableTracking}
            startManually={true}
            timeout={Constants.IDLE_TIME}
            onIdle={onIdle}>
            <div className={classes.root}>
                {isLoading && useSpinner(isLoading)}
                <EfeUserProvider>
                    <EfeFlowProvider>
                        <EfeRelatedPeopleProvider>
                            <EfeBeneficiaryProvider>
                                <Sidebar />
                                <Container
                                    component='main'
                                    disableGutters
                                    maxWidth={false}
                                    className={classes.content}>
                                    <Routing routes={menu} />
                                </Container>
                            </EfeBeneficiaryProvider>
                        </EfeRelatedPeopleProvider>
                    </EfeFlowProvider>
                </EfeUserProvider>
            </div>
        </EfeTrack>
    );
}

Admin.propTypes = {};

export default withStyles(AdminStyles)(Admin);
